import { styled, useTheme } from "@mui/material/styles";
import React, { useEffect } from "react";
import axios from "axios";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { withRouter, useHistory, useLocation } from "react-router-dom";

import { useState } from "react";
import DashboardColoredImg from "../../Images/DashboardColoredImg.png";
import IncomeColoredImg from "../../Images/IncomeColoredImg.png";
import GlobalColoredImg from "../../Images/GlobalColoredImg.png";
import SupplyColoredImg from "../../Images/SupplyColoredImg.png";
import DemandColoredImg from "../../Images/DemandColoredImg.png";
import CampaignManagementColor from "../../Images/CampaignManagementColor.png";
import OpportunityRadarColor from "../../Images/OpportunityRadarColor.png";
import DashboardImg from "../../Images/DashboardImg.png";
import IncomeImg from "../../Images/IncomeImg.png";
import GlobalImg from "../../Images/GlobalImg.png";
import SupplyImg from "../../Images/SupplyImg.png";
import DemandImg from "../../Images/DemandImg.png";
import O2RLogo from "../../Images/O2RLogo.png";
import CampaignManagementImage from "../../Images/CampaignManagementImage.png";
import OpportunityRadarImage from "../../Images/OpportunityRadarImage.png";
import Mediasource1 from "../../Images/Mediasource1.png";
import MediasourceColor1 from "../../Images/MediasourceColor1.png";
var pageWidth = window.innerWidth;
const drawerWidth = 280;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});
const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(pageWidth < 766 ? 0 : 7)} + 0px)`,
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 0),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
var HidePages = "";

export default function MainPageLeftDrawer({ WidthFromMainPage }) {
  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  pageWidth = WidthFromMainPage;

  const classes = ""; //useStyles();
  const [open, setOpen] = React.useState(false);
  const [myText, setMyText] = React.useState("");
  const [goToPage, setGoToPage] = React.useState();

  let history = useHistory();

  useEffect(() => {
    const index = window.location.href.indexOf("Dashboard");
    if (index !== -1) {
      setMyText("Dashboard");
      console.log("yes");
    } else {
      setMyText("Source Management");
      console.log("no");
    }
  }, []);

  var LeftImages1 = [
    DashboardColoredImg,
    IncomeColoredImg,
    GlobalColoredImg,
    SupplyColoredImg,
    DemandColoredImg,
    CampaignManagementColor,
    OpportunityRadarColor,
    MediasourceColor1,
  ];
  var LeftImages2 = [
    DashboardImg,
    IncomeImg,
    GlobalImg,
    SupplyImg,
    DemandImg,
    CampaignManagementImage,
    OpportunityRadarImage,
    Mediasource1,
  ];

  return (
    <div
      style={{
        display: "flex", // width > 766 ? "flex" : "",
        flexGrow: 1,
      }}
    >
      <Drawer
        variant="permanent"
        open={open}
        classes={{ paper: classes.drawerPaper }}
      >
        <div
          style={{
            display: open === true ? "flex" : "",
            flexDirection: "row",
            alignItems: open === true ? "center" : "",
            justifyContent: open === true ? "space-between" : "",
          }}
        >
          {open === true ? (
            <div style={{ paddingLeft: "10%" }} onClick={() => {}}>
              <img src={O2RLogo} width={40}></img>{" "}
            </div>
          ) : (
            <></>
          )}

          <DrawerHeader>
            <IconButton
              style={{}}
              onClick={() => {
                setOpen(!open);
              }}
            >
              {open === true ? (
                <ChevronLeftIcon />
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      left: "25%",
                      alignItems: "center",
                    }}
                  >
                    <img src={O2RLogo} width={40}></img>
                    <ChevronRightIcon />
                  </div>
                </>
              )}
            </IconButton>
          </DrawerHeader>
        </div>
        {/* <Divider /> */}
        <List>
          {[
            "Dashboard",
            "Source Management",
            "Bundle Management",
            "White Lists",
            "RTB Management",
            "RTB List",
            "Auto Tasks",
          ].map((text, index) => (
            <ListItem key={text} disablePadding sx={{ display: "block" }}>
              <div
                onClick={() => {
                  if (index === 0) {
                    history.push(`/Dashboard/`);
                    setGoToPage(index);
                    setMyText("Dashboard");
                    console.log(myText);
                  }
                  if (index === 1) {
                    history.push(`/SourceManagement/`);
                    setGoToPage(index);
                    setMyText("Source Management");
                    console.log(myText);
                  }
                  if (index === 2) {
                    history.push(`/BundleManagement/`);
                    setGoToPage(index);
                    setMyText("Bundle Management");
                    console.log(myText);
                  }
                  if (index === 3) {
                    history.push(`/WhiteLists/`);
                    setGoToPage(index);
                    setMyText("White Lists");
                    console.log(myText);
                  }
                  if (index === 4) {
                    history.push(`/RTBManagement/`);
                    setGoToPage(index);
                    setMyText("RTB Management");
                    console.log(myText);
                  }
                  if (index === 5) {
                    history.push(`/RTBList/`);
                    setGoToPage(index);
                    setMyText("RTB List");
                    console.log(myText);
                  }
                  if (index === 6) {
                    history.push(`/AutoTasks/`);
                    setGoToPage(index);
                    setMyText("Auto Tasks");
                    console.log(myText);
                  }
                }}
                style={{
                  color: myText === text ? "#5746af" : "",
                  background: text === myText ? "#e4defc" : "",
                  borderRadius: 10,
                  margin: 5,
                }}
              >
                {(HidePages === "accountManager" && text === "Media Source") ||
                (HidePages === "accountManager" && text === "Dashboard") ||
                (HidePages === "accountManager" &&
                  text === "Income Reports") ? (
                  <></>
                ) : (
                  <ListItemButton sx={{ pl: open ? 2 : 2 }}>
                    <ListItemIcon>
                      <img
                        src={
                          text === myText
                            ? LeftImages1[index]
                            : LeftImages2[index]
                        }
                        width={20}
                      ></img>{" "}
                    </ListItemIcon>
                    <ListItemText primary={text} />
                  </ListItemButton>
                )}
              </div>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </div>
  );
}
